import { BLOCK_UI, UNBLOCK_UI } from './types';

export const blockUi = (block, message) => block ? { type: BLOCK_UI, message } : { type: UNBLOCK_UI };